import { DEVISE } from './currency';

export const splitNpa = (npa) => {
  const m = String(npa || '')
    .trim()
    .match(/^(\d{4,5})\s+(.*)$/);
  return m ? { cp: m[1], ville: m[2] } : { cp: '', ville: String(npa || '').trim() };
};

export const swissQR = ({
  iban,
  nom,
  adr,
  npa,
  amount,
  clientNom,
  clientAdr,
  clientNpa,
  refType,
  ref,
  msg,
}) => {
  const c = splitNpa(npa),
    d = splitNpa(clientNpa);
  return [
    'SPC',
    '0200',
    '1',
    String(iban || '')
      .replace(/\s/g, '')
      .toUpperCase(),
    'S',
    nom || '',
    adr || '',
    '',
    c.cp,
    c.ville,
    'CH',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    Number(amount || 0).toFixed(2),
    DEVISE,
    'S',
    clientNom || '',
    clientAdr || '',
    '',
    d.cp,
    d.ville,
    'CH',
    refType || 'NON',
    ref || '',
    msg || '',
    'EPD',
  ].join('\n');
};

export const epcQR = ({ bic, nom, iban, amount, ref, msg }) => {
  const amt = amount && +amount > 0 ? 'EUR' + Number(amount).toFixed(2) : '';
  const r = String(ref || '').trim();
  return [
    'BCD',
    '002',
    '1',
    'SCT',
    String(bic || '').trim(),
    String(nom || '').slice(0, 70),
    String(iban || '')
      .replace(/\s/g, '')
      .toUpperCase(),
    amt,
    '',
    r ? r.slice(0, 35) : '',
    r ? '' : String(msg || '').slice(0, 140),
  ].join('\n');
};
